<app-navbar></app-navbar>
<div class="wrapper-public">
  <router-outlet (activate)="onActivate()"></router-outlet>
  <app-footer></app-footer>
</div>
